export const ACTION_TYPES = {
  CHANGE_STEP: 'CHANGE_STEP',
  FETCH_ADDRESS_BY_ZIPCODE: 'FETCH_ADDRESS_BY_ZIPCODE',
  LOADING: 'LOADING',
  SET_STEP_VALUES: 'SET_STEP_VALUES',
  SET_ORGANIZATION: 'SET_ORGANIZATION',
  INITIALIZE_FROM_STORAGE: 'INITIALIZE_FROM_STORAGE',
  SET_PAYMENT_PROFILE: 'SET_PAYMENT_PROFILE',
  CLEAR_SUBSCRIPTION: 'CLEAR_SUBSCRIPTION',
};
